// extracted by mini-css-extract-plugin
export var categories = "fw_l9";
export var footerTop = "fw_l8";
export var footnote = "fw_cM";
export var footnoteContainer = "fw_hW";
export var subscriptionContainer = "fw_mb";
export var wrapper = "fw_cc";